import React from "react";
import StepShell from "./StepShell";

// Message-only step with an optional primary button
// (estimate, good news, not eligible).
const InfoStep = ({ title, text, note, button, onNext, onBack }) => (
  <StepShell title={title} subtitle={text} onBack={onBack}>
    {note && <p className="rp-hint rp-note">{note}</p>}
    {button && (
      <div className="rp-actions">
        <button type="button" className="rp-btn" onClick={onNext}>
          {button}
        </button>
      </div>
    )}
  </StepShell>
);

export default InfoStep;
